// extracted by mini-css-extract-plugin
export default {"wrap":"GenerationRoute-module__wrap--ST7Po","topBar":"GenerationRoute-module__topBar--c0TG4","body":"GenerationRoute-module__body--ZeUpa"};